
import { getAllItems, updateItem} from './bdd';
import * as global from './global';
import { writeLogMsg } from './log';

export const sendAllData = async (source) => {
    const allItems = await getAllItems();
    writeLogMsg(source + ': Webservice: sendAllData: allItems:', allItems);
    
    for (var shipment of allItems) {
        writeLogMsg(source + ': Webservice: sendAllData: shipment:', shipment);
    
        // Vérifier si l'élément a déjà été envoyé
        if (shipment.Sent) {
            continue; // Passer à l'élément suivant si déjà envoyé
        }
    
        const atOptions = {
            method: 'POST',
            timeout: global.HTTP_TIMEOUT,
            cache: 'no-cache',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify(shipment),
        };
    
        // Construire l'URL
        let astrUrl = global.APP_URL + global.WS_UPLOAD;
        astrUrl = astrUrl.replace("%KEY%", shipment.Customer.code);
        astrUrl = astrUrl.replace("%ID%", shipment.Customer.id);
    
        writeLogMsg(source + ': Webservice: sendAllData: URL:', astrUrl);
        writeLogMsg(source + ': Webservice: sendAllData: item:', shipment);
    
        // Télécharger l'envoi vers le serveur
        try {
            const response = await fetch(astrUrl, atOptions);
            writeLogMsg(source + ': Webservice: sendAllData: Response:', response);
    
            if (response.ok) {
                shipment.Sent = true; // Marquer comme envoyé
                writeLogMsg(source + ': Webservice: sendAllData: Item updated:', shipment);
    
                // Mettre à jour l'élément dans la base de données
                await updateItem(shipment);
            }
        } catch (error) {
            console.error(source, ': Webservice: sendAllData: Error:', error);
        }
    }
}


export const sendData = async (source, shipment) => {
    var atOptions = {
        method: 'POST',
        timeout: global.HTTP_TIMEOUT,
        cache: 'no-cache',
        params: { 'fixCache': new Date().getTime() },
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(shipment)
    };

    // Construct url
    var astrUrl = global.APP_URL + global.WS_UPLOAD;
    astrUrl = astrUrl.replace("%KEY%", shipment.Customer.code);
    astrUrl = astrUrl.replace("%ID%", shipment.Customer.id);

    writeLogMsg(source + ': Webservice: sendData: URL:', astrUrl);
    writeLogMsg(source + ': Webservice: sendData: shipment:', shipment);

    // Télécharger l'envoi vers le serveur
    try {
        const response = await fetch(astrUrl, atOptions);
        writeLogMsg(source + ': Webservice: sendData: Response:', response);

        if (response.ok === true) {
            shipment.Sent = true; // Marquer comme envoyé
            writeLogMsg(source + ': Webservice: sendData: Shipment updated:', shipment);

            // Mettre à jour l'élément dans la base de données
            await updateItem(shipment);
        }
    } catch (error) {
        console.error(source, ': Webservice: sendData: Error:', error);
    }
}

export const getSettings = async (source, id) => {
    var atOptions = {
        method: 'GET',
        timeout: global.HTTP_TIMEOUT,
        cache: 'no-cache',
        params: { 'fixCache': new Date().getTime() },
        headers: {
            'Content-Type': 'application/json'
        }
    };

    //writeLogMsg(source + ': Webservice: getSettings: atOptions:', atOptions);
    // Construct url
    var astrUrl = global.APP_URL + global.WS_SETTINGS;
    astrUrl = astrUrl.replace("%ID%", id);

    //writeLogMsg(source + ': Webservice: getSettings: URL:', astrUrl);
    //writeLogMsg(source + ': Webservice: getSettings: ID:', id);

    // Récupérer les paramètres de configuration
    try {
        const response = await fetch(astrUrl, atOptions);
        //writeLogMsg(source + ': Webservice: getSettings: Response:', response);
        if (response.ok === true) {
            const settings = await response.json();
            //writeLogMsg(source + ': Webservice: getSettings: Settings:', settings);
            return settings;
        } else {
            console.error(source + ': Webservice: getSettings: Failed to fetch settings');
            throw new Error('Failed to fetch settings');
        }
    } catch (error) {
        console.error(source, ': Webservice: getSettings: Error:', error);
        return { APP_LOG_ENABLED: global.APP_LOG_ENABLED }; // Return default value if error occurs
    }
}